import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ProductionPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "Production Company | L+TV TÉLÉVISION";
  }, []);

  const services = [
    { title: t("production.svc.tv.title"), description: t("production.svc.tv.desc"), icon: "ri-tv-line" },
    { title: t("production.svc.video.title"), description: t("production.svc.video.desc"), icon: "ri-video-line" },
    { title: t("production.svc.interviews.title"), description: t("production.svc.interviews.desc"), icon: "ri-mic-line" },
    { title: t("production.svc.event.title"), description: t("production.svc.event.desc"), icon: "ri-broadcast-line" },
    { title: t("production.svc.commercial.title"), description: t("production.svc.commercial.desc"), icon: "ri-shopping-bag-line" },
    { title: t("production.svc.documentary.title"), description: t("production.svc.documentary.desc"), icon: "ri-file-video-line" },
    { title: t("production.svc.studio.title"), description: t("production.svc.studio.desc"), icon: "ri-building-3-line" },
  ];

  return (
    <div className="pt-20">
      <div className="bg-primary-900 py-8">
        <div className="ltv-container">
          <h1 className="text-2xl md:text-3xl font-bold text-white">{t("production.title")}</h1>
          <p className="text-white/60 text-sm mt-1">{t("production.subtitle")}</p>
        </div>
      </div>

      <div className="ltv-container py-8 md:py-12">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-foreground-700 leading-relaxed text-lg">
            {t("production.intro")}
          </p>
        </div>

        <h2 className="ltv-section-title">{t("production.servicesTitle")}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {services.map((s) => (
            <div key={s.title} className="bg-white rounded-lg border border-background-200 p-5">
              <div className="w-12 h-12 bg-primary-50 rounded-lg flex items-center justify-center text-primary-600 mb-3">
                <i className={`${s.icon} text-xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 mb-2">{s.title}</h3>
              <p className="text-sm text-foreground-600">{s.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-primary-50 rounded-lg border border-primary-100 p-8 text-center">
          <h3 className="text-lg font-bold text-primary-900 mb-2">{t("production.ctaTitle")}</h3>
          <p className="text-sm text-primary-700 mb-4">{t("production.ctaDesc")}</p>
          <Link to="/contact" className="ltv-btn-accent text-sm inline-flex items-center gap-2">
            {t("production.getInTouch")}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}